var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoftwareUpdatesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6509 5.41794C14.6509 5.41794 15.874 4.81543 11.4375 4.81543C9.84865 4.81543 8.29546 5.28658 6.97436 6.16931C5.65327 7.05204 4.6236 8.30669 4.01557 9.77462C3.40753 11.2425 3.24844 12.8578 3.55842 14.4161C3.86839 15.9745 4.6335 17.4059 5.757 18.5294C6.8805 19.6529 8.31193 20.418 9.87026 20.728C11.4286 21.038 13.0439 20.8789 14.5118 20.2708C15.9797 19.6628 17.2344 18.6331 18.1171 17.312C18.9998 15.9909 19.471 14.4378 19.471 12.8489",
    stroke: "#9593BF",
    strokeWidth: 1.60669,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4375 1L15.4542 5.01673L11.4375 9.03346",
    stroke: "#9593BF",
    strokeWidth: 1.60669,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareUpdatesIcon);
export default __webpack_public_path__ + "static/media/software-updates-icon.2389edea6d1fa143a6d6dd2593bf3d0d.svg";
export { ForwardRef as ReactComponent };